@layer module {
} // layer module










@layer app {
.select-currency-wrapper {
            margin-bottom: $size-20;
    }

.select-currency-label {
            margin-bottom: $size-5;
    }

.currency-button-styled {
            height: $size-44;
            padding-left: $size-10;
            padding-right: $size-18;
    }

.select-currency-label {
            color: var(--custom-selector-content);
            font-size: var(--font-size-sm);
            font-style: normal;
            font-weight: 500;
            line-height: $size-14;
    }

.select-currency-label .required {
            color: var(--custom-selector-required);
    }

.currency-button-styled {
            border: 1px solid var(--border-neutral-light);
    }

.currency-button-styled .no-currency {
            padding-right: var(--input-placeholder-inline-inset);
            color: var(--custom-selector-control-text);
    }

.currency-styled .content {
            font-size: var(--font-size-base);
            font-style: normal;
            font-weight: 400;
    }
} // layer app
